export const FETCH_GAME_FANTASYTEAMS_REQUEST       = 'game/fantasyteams/fetch/request';
export const FETCH_GAME_FANTASYTEAMS_SUCCESS       = 'game/fantasyteams/fetch/success';
export const FETCH_GAME_FANTASYTEAMS_FAIL          = 'game/fantasyteams/fetch/fail';

export const FETCH_LINEUP_REQUEST                   = 'FETCH_LINEUP_REQUEST';
export const FETCH_LINEUP_SUCCESS                   = 'FETCH_LINEUP_SUCCESS';
export const FETCH_LINEUP_FAIL                      = 'FETCH_LINEUP_FAIL';
